export default "__VITE_ASSET__DL8yiwb9__"